import { ReactElement } from "react";
import Detail from "./detail";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { IRequest, useFetch } from "../../system/useFetch";

interface IQueryComponentProps {
  request: IRequest;
  onDataArrived: (data: any) => ReactElement;
  onClosed: () => void;
}

const QueryDialog = ({ request, onDataArrived, onClosed }: IQueryComponentProps): ReactElement => {
  const { loading, error, data } = useFetch<any[]>(request);

  return(
    <Detail closed={onClosed} fullWidth={true} maxWidth={"xl"} title="Detail">
      <>
        { loading && <div className="text-center"><CircularProgress /></div> }
        { error && <Alert severity="warning">{error.message}</Alert> }
        { data && onDataArrived(data) }
      </>
    </Detail>
  );
};

export default QueryDialog;
